/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { classNames as f, kendoThemeMaps as d } from "@progress/kendo-react-common";
import { FormContext as p } from "./FormContext.mjs";
const h = e.forwardRef((o, a) => {
  const m = {
    size: "medium",
    ...o
  }, s = e.useRef(null), n = e.useRef(null);
  e.useImperativeHandle(n, () => ({ element: s.current, props: m })), e.useImperativeHandle(a, () => n.current);
  const t = e.useContext(p), { className: l, style: z, horizontal: i, size: r, ...c } = m, u = f(
    {
      "k-form": !0,
      [`k-form-${d.sizeMap[r] || r}`]: r,
      "k-form-horizontal": i === !0
    },
    l
  );
  return /* @__PURE__ */ e.createElement(
    "form",
    {
      ref: s,
      ...c,
      id: t ? t.id : void 0,
      style: o.style,
      className: u,
      onSubmit: t ? t.onSubmit : void 0
    },
    o.children
  );
});
h.displayName = "KendoReactFormElement";
export {
  h as FormElement
};
